import BasePage from "./basePage";
import SubController from "../subDeath/subController";
import { page3info } from "../subDeath/subpageInfo";
import Page3Sub1 from "../subDeath/page3_sub1";
import Page3Sub2 from "../subDeath/page3_sub2";
import Page3Sub3 from "../subDeath/page3_sub3";
import Page3Sub4 from "../subDeath/page3_sub4";

export default class Page3 extends BasePage{
    constructor(info){
        super(info);
        super.set();

        this.ele = info.ele;
        page3info.sub1.class = new Page3Sub1( page3info.sub1 );
        page3info.sub2.class = new Page3Sub2( page3info.sub2 );
        page3info.sub3.class = new Page3Sub3( page3info.sub3 );
        page3info.sub4.class = new Page3Sub4( page3info.sub4 );

        this.subController = new SubController( page3info );

        this._init();
        this._bindEvent();
    }

    _init(){
        viewCtrl();
        const swipers = {
            sub1: new Swiper('#subSwiper-1', {
                navigation: {
                    nextEl: '#subSwiper-1 .btn-next',
                    prevEl: '#subSwiper-1 .btn-prev',
                },
                simulateTouch: false
            }),
            sub2: new Swiper('#subSwiper-2', {
                navigation: {
                    nextEl: '#subSwiper-2 .btn-next',
                    prevEl: '#subSwiper-2 .btn-prev',
                },
                simulateTouch: false
            })
        }
    }

    _bindEvent(){
        $(this.ele).find('.tab-tit button').on('click', (e)=>{
            $(this.ele).find('.tab-tit li').removeClass('on');
            this.subController.change( e.currentTarget.getAttribute('data-key') );
        })
        // this.ele.addEventListener('onComplete', this._pageMotion.bind(this) );
    }

    show(){
        super.show();
        this.subController.init('sub1');
    }

    hide(){
        super.hide();
        this.subController.hide();
    }
}


const viewCtrl = ()=>{
    let _url, views = {};
    if( window.location.href.indexOf('rc.') > 0 ){
        _url = 'https://rc-wstatic.plaync.co.kr/promo/bns/history/2019/190612_archery/';
    }
    else if( window.location.href.indexOf('opdev.') > 0 ){
        _url = 'https://op-wstatic.ncsoft.com//promo/bns/history/2019/190612_archery/'
    }
    else if( window.location.href.indexOf('local.') > 0 ){
        _url = 'https://op-wstatic.ncsoft.com//promo/bns/history/2019/190612_archery/'
    }
    else {
        _url = 'https://wstatic-cdn.plaync.com/promo/bns/history/2019/190612_archery/'
    }

    views['v1'] = new nc.ui.Viewer({
        image: [
            {src: _url+"img/page3/view/img_b_1_1.jpg"},
            {src: _url+"img/page3/view/img_b_1_2.jpg"},
            {src: _url+"img/page3/view/img_b_1_3.jpg"},
            {src: _url+"img/page3/view/img_b_1_4.jpg"}
        ],
        btn: '.sub-1 .btn-opener'
    });
    views['v2'] = new nc.ui.Viewer({
        image: [
            {src: _url+"img/page3/view/img_b_2_1.jpg"},
            {src: _url+"img/page3/view/img_b_2_2.jpg"},
            {src: _url+"img/page3/view/img_b_2_3.jpg"},
            {src: _url+"img/page3/view/img_b_2_4.jpg"},
            {src: _url+"img/page3/view/img_b_2_5.jpg"}
        ],
        btn: '.sub-2 .btn-opener'
    });
    views['v3'] = new nc.ui.Viewer({
        image: [
            {src: _url+"img/page3/view/img_b_3_1.jpg"}
        ],
        btn: '.sub-3 .btn-opener'
    });
    views['v4'] = new nc.ui.Viewer({
        image: [
            {src: _url+"img/page3/view/img_b_4_1.jpg"}
        ],
        btn: '.sub-4 .btn-opener'
    });
};


// WEBPACK FOOTER //
// ./src/js/mainDeath/page3.js